import { Modal } from '@gerdau/hefesto/Modal';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { sendTagging } from '../../../../../../../../store/ducks/tagging/actions';

interface ICancelOrderModal {
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
}
const CancelOrderModal: React.FC<ICancelOrderModal> = ({
  onClose,
  onConfirm,
  loading
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      sendTagging({
        event: 'page_view',
        page: window.location.pathname,
        screenName:
          'LG:MeusPedidos:AcosLongos:PedidosAbertos:ModalCancelarPedidos'
      })
    );
  }, []);

  const handleClose = () => {
    dispatch(
      sendTagging({
        event: 'click',
        itemName: 'button:cancelar',
        screenName:
          'LG:MeusPedidos:AcosLongos:PedidosAbertos:ModalCancelarPedidos',
        itemDescription:
          'meus_pedidos_acosLongos_pedidosAbertos_cancelarPedidos_cancelar'
      })
    );
    onClose();
  };

  const handleConfirm = () => {
    dispatch(
      sendTagging({
        event: 'click',
        itemName: 'button:confirmar',
        screenName:
          'LG:MeusPedidos:AcosLongos:PedidosAbertos:ModalCancelarPedidos',
        itemDescription:
          'meus_pedidos_acosLongos_pedidosAbertos_cancelarPedidos_confirmar'
      })
    );
    onConfirm();
  };
  return (
    <Modal
      title="Você tem certeza que quer solicitar o cancelamento desse item?"
      buttons={{
        right: {
          disabled: loading,
          loading: loading,
          children: 'Sim, quero cancelar',
          name: 'confirm-button',
          onClick: handleConfirm,
          type: 'button'
        },
        left: {
          disabled: loading,
          children: 'Não quero cancelar',
          name: 'cancel-modal',
          onClick: handleClose,
          type: 'button'
        }
      }}
      onClose={!loading ? handleClose : undefined}
    >
      Ao solicitar o cancelamento, o processo será analisado pela central de
      atendimento, que entrará em contato através do email cadastrado.
      <br />
      <br />
      <strong>Fique atento ao email de acesso e a caixa de spam</strong>
    </Modal>
  );
};

export default CancelOrderModal;
